import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import { ErrorBanner, Link } from '@trp-rps-rps-shared-web/rps-shared-web-components';
import InputTilesContainer from '../InputTilesContainer/InputTilesContainer';
import ChartsContainer from '../ChartsContainer/Charts';
import { modals, accountModalViews } from '../../utils/constants';
import { keyDown } from '../../utils/helpers';
import { accountActions, modalActions } from '../../redux/root-action';

const StyledOuterContainer = styled.div<{ name?: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 80px;
  @media (max-width: 1023px) {
    margin-bottom: 0;
  }
`;

const StyledInnerContainer = styled.div`
  width: 1120px;
  @media only screen and (max-width: 1024px) {
    width: 100%;
  }
`;

const StyledTitleDesktop = styled.div`
  font-size: 32px;
  padding: 32px 32px 32px 0px;
  color: ${tokens.ColorGrey800};
  font-family: Nimbus Sans Bold;

  @media (min-width: 1024px) and (max-width: 1199px) {
    padding: 32px 48px;
  }

  @media (max-width: 1023px) {
    display: none;
  }
`;

const StyledTitleMobile = styled.div`
  padding: 32px 32px 32px 0px;
  color: ${tokens.ColorGrey800};
  font-family: Nimbus Sans Bold;
  background-color: ${tokens.ColorWhite050};
  font-size: 24px;
  line-height: 32px;

  @media (min-width: 768px) and (max-width: 1023px) {
    padding: 40px 40px 24px;
  }
  @media (max-width: 767px) {
    padding: 40px 16px 24px;
  }
  @media (min-width: 1024px) {
    display: none;
  }
`;

const StyledContainer = styled.div`
  display: flex;
  justify-content: space-between;
  @media only screen and (max-width: 1023px) {
    flex-direction: column;
  }
  @media (min-width: 1024px) and (max-width: 1199px) {
    padding: 0 48px;
  }
  @media (max-width: 1023px) {
    padding: 0;
  }
`;

const StyledChartContainer = styled.div`
  width: 736px;
  min-height: 600px;
  border-radius: 8px;
  background-color: ${tokens.ColorWhite000};
  box-shadow: 0 8px 8px 0 rgba(45, 57, 64, 0.06), 0 0 4px 0 rgba(45, 57, 64, 0.06);

  @media (min-width: 1024px) and (max-width: 1199px) {
    width: 528px;
    position: relative;
  }
  @media (min-width: 768px) and (max-width: 1023px) {
    width: 100%;
    padding: 40px 40px 24px;
  }
  @media (max-width: 767px) {
    width: 100%;
    padding: 40px 16px 24px;
    min-height: auto;
  }
`;

class StrategyContainer extends Component<any> {
  props: any;
  state: any;
  constructor(props: any) {
    super(props);
    this.state = {
      showInputTiles: true,
    };
  }

  showYourAccountsModal = () => {
    const { showModal, setCurrentView } = this.props;
    showModal(modals.ACCOUNT);
    setCurrentView(accountModalViews.YOUR_ACCOUNTS);
  };

  render(): JSX.Element {
    const { hasYodleeErrors } = this.props;
    const styledTitle = 'See the impact of adjusting your strategy';

    return (
      <StyledOuterContainer name="strategy-container">
        <StyledInnerContainer>
          {hasYodleeErrors && (
            <ErrorBanner>
              There seem to be one or more errors in your linked accounts.
              <Link
                linkLabel={'Review your account(s).'}
                onClick={this.showYourAccountsModal}
                tabIndex={0}
                onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyDown(e, this.showYourAccountsModal)}
                color={tokens.ColorBrandInteractiveBlue}
                hoverColor={tokens.ColorBrandInteractiveBlueHover}
                customStyles={'display: inline; text-decoration: underline; margin-left: 4px;'}
              />
            </ErrorBanner>
          )}
          <StyledTitleDesktop>{styledTitle}</StyledTitleDesktop>
          <StyledContainer>
            <StyledChartContainer>
              <ChartsContainer />
            </StyledChartContainer>
            <StyledTitleMobile>{styledTitle}</StyledTitleMobile>
            <InputTilesContainer />
          </StyledContainer>
        </StyledInnerContainer>
      </StyledOuterContainer>
    );
  }
}

const mapStateToProps = ({
  account: {
    modelledScenario: { accounts },
  },
}: any) => {
  return {
    hasYodleeErrors: accounts && accounts.some((account: any) => account.hasYodleeError),
  };
};

export default connect(mapStateToProps, {
  showModal: modalActions.showModal,

  setCurrentView: accountActions.setCurrentView,
})(StrategyContainer);
